// import React, { useState } from 'react';
// import { 
//   Phone, 
//   Mail, 
//   MapPin, 
//   Clock, 
//   Send,
//   CheckCircle,
//   User,
//   MessageSquare,
//   Calendar,
//   AlertCircle,
//   Facebook,
//   Instagram,
//   Twitter,
//   Linkedin,
//   Youtube
// } from 'lucide-react';

// const ContactPage = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     subject: '',
//     message: '',
//     preferredDate: '',
//     preferredTime: ''
//   });

//   const [formStatus, setFormStatus] = useState(null);

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setFormStatus('success');
//     setTimeout(() => {
//       setFormStatus(null);
//       setFormData({
//         name: '',
//         email: '',
//         phone: '',
//         subject: '',
//         message: '',
//         preferredDate: '',
//         preferredTime: ''
//       });
//     }, 3000);
//   };

//   const contactInfo = [
//     {
//       icon: <MapPin className="w-6 h-6" />,
//       title: "Visit Our Clinic",
//       details: ["4th Floor, Gyani Arcade", "Suncity Main Road, Hydershakote,", "Rajendranagar, Ranga Reddy District – 500091"],
// //       4th Floor, Gyani Arcade, Suncity Main Road, Hydershakote,
// // Rajendranagar, Ranga Reddy District – 500091
//       color: "#E86A33"
//     },
//     {
//       icon: <Phone className="w-6 h-6" />,
//       title: "Call Us",
//       details: ["+91 9989162222",],
//       color: "#2C85B8"
//     },
//     {
//       icon: <Mail className="w-6 h-6" />,
//       title: "Email Us",
//       details: ["vayulungcare@gmail.com"],
//       color: "#1B4965"
//     },
//     {
//       icon: <Clock className="w-6 h-6" />,
//       title: "Working Hours",
//       details: ["Mon - Sat: 9:00 AM - 9:00 PM", "Sunday: 9:00 AM - 1:00 PM", ],
//       color: "#62B6CB"
//     }
//   ];

//   const departments = [
//     "Pulmonology",
//     "Cardiology",
//     "Critical Care",
//     "General Medicine",
//     "Allergy Testing",
//     "Diagnostics"
//   ];

//   const socialLinks = [
//     { icon: <Facebook size={20} />, href: "#", color: "#1877F2" },
//     { icon: <Instagram size={20} />, href: "#", color: "#E4405F" },
//     { icon: <Twitter size={20} />, href: "#", color: "#1DA1F2" },
//     { icon: <Linkedin size={20} />, href: "#", color: "#0A66C2" },
//     { icon: <Youtube size={20} />, href: "#", color: "#FF0000" }
//   ];

//   return (
//     <>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;800&family=Inter:wght@300;400;500;600;700;800&display=swap');
        
//         * {
//           margin: 0;
//           padding: 0;
//           box-sizing: border-box;
//         }

//         body {
//           font-family: 'Inter', sans-serif;
//           color: #1a1a1a;
//         }

//         .contact-page {
//           width: 100%;
//           min-height: 100vh;
//           background: linear-gradient(135deg, #F8FAFB 0%, white 100%);
//         }

//         /* Hero Section */
//         .contact-hero {
//           position: relative;
//           height: 50vh;
//           min-height: 400px;
//           background: linear-gradient(135deg, #1B4965 0%, #2C5F7C 100%);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           overflow: hidden;
//         }

//         .contact-hero::before {
//           content: '';
//           position: absolute;
//           top: -50%;
//           right: -20%;
//           width: 70%;
//           height: 200%;
//           background: radial-gradient(circle, rgba(232, 106, 51, 0.15) 0%, transparent 70%);
//           animation: rotate 30s linear infinite;
//         }

//         @keyframes rotate {
//           from { transform: rotate(0deg); }
//           to { transform: rotate(360deg); }
//         }

//         .contact-hero-content {
//           text-align: center;
//           color: white;
//           z-index: 2;
//           max-width: 800px;
//           padding: 2rem;
//         }

//         .contact-label {
//           font-size: 0.95rem;
//           font-weight: 700;
//           color: #FFD700;
//           letter-spacing: 4px;
//           text-transform: uppercase;
//           margin-bottom: 1.5rem;
//           animation: fadeInDown 0.8s ease;
//         }

//         .contact-hero-title {
//           font-family: 'Playfair Display', serif;
//           font-size: 4rem;
//           font-weight: 800;
//           margin-bottom: 1rem;
//           line-height: 1.1;
//           animation: fadeInUp 0.8s ease 0.2s both;
//         }

//         .contact-hero-subtitle {
//           font-size: 1.3rem;
//           opacity: 0.95;
//           font-weight: 300;
//           animation: fadeInUp 0.8s ease 0.4s both;
//         }

//         @keyframes fadeInDown {
//           from { opacity: 0; transform: translateY(-30px); }
//           to { opacity: 1; transform: translateY(0); }
//         }

//         @keyframes fadeInUp {
//           from { opacity: 0; transform: translateY(30px); }
//           to { opacity: 1; transform: translateY(0); }
//         }

//         /* Contact Info Cards */
//         .contact-info-section {
//           max-width: 1400px;
//           margin: -80px auto 0;
//           padding: 0 2rem 4rem;
//           position: relative;
//           z-index: 10;
//         }

//         .contact-info-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
//           gap: 2rem;
//           margin-bottom: 4rem;
//         }

//         .contact-info-card {
//           background: white;
//           border-radius: 25px;
//           padding: 2.5rem;
//           box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
//           transition: all 0.4s ease;
//           position: relative;
//           overflow: hidden;
//         }

//         .contact-info-card::before {
//           content: '';
//           position: absolute;
//           top: 0;
//           left: 0;
//           right: 0;
//           height: 5px;
//           transform: scaleX(0);
//           transform-origin: left;
//           transition: transform 0.4s ease;
//         }

//         .contact-info-card:hover::before {
//           transform: scaleX(1);
//         }

//         .contact-info-card:hover {
//           transform: translateY(-10px);
//           box-shadow: 0 20px 60px rgba(27, 73, 101, 0.15);
//         }

//         .contact-icon-wrapper {
//           width: 70px;
//           height: 70px;
//           border-radius: 18px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           color: white;
//           margin-bottom: 1.5rem;
//           transition: all 0.4s ease;
//         }

//         .contact-info-card:hover .contact-icon-wrapper {
//           transform: rotate(-5deg) scale(1.1);
//         }

//         .contact-info-title {
//           font-size: 1.3rem;
//           font-weight: 700;
//           color: #1B4965;
//           margin-bottom: 1rem;
//           font-family: 'Playfair Display', serif;
//         }

//         .contact-info-details {
//           display: flex;
//           flex-direction: column;
//           gap: 0.5rem;
//         }

//         .contact-detail-item {
//           font-size: 0.95rem;
//           color: #666;
//           line-height: 1.6;
//         }

//         .contact-detail-item a {
//           color: #666;
//           text-decoration: none;
//           transition: color 0.3s ease;
//         }

//         .contact-detail-item a:hover {
//           color: #E86A33;
//         }

//         /* Main Content */
//         .contact-main {
//           max-width: 1400px;
//           margin: 0 auto;
//           padding: 0 2rem 6rem;
//           display: grid;
//           grid-template-columns: 1fr 1.2fr;
//           gap: 4rem;
//           align-items: start;
//         }

//         /* Map Section */
//         .map-section {
//           position: sticky;
//           top: 120px;
//         }

//         .map-container {
//           background: white;
//           border-radius: 25px;
//           overflow: hidden;
//           box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
//           margin-bottom: 2rem;
//         }

//         .map-placeholder {
//           width: 100%;
//           height: 400px;
//           background: linear-gradient(135deg, #e0e0e0 0%, #f5f5f5 100%);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           position: relative;
//         }

//         .map-iframe {
//           width: 100%;
//           height: 400px;
//           border: none;
//         }

//         .get-directions-btn {
//           width: 100%;
//           padding: 1.2rem;
//           background: linear-gradient(135deg, #E86A33, #FF9B6E);
//           color: white;
//           border: none;
//           font-weight: 700;
//           font-size: 1rem;
//           cursor: pointer;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 0.7rem;
//           transition: all 0.3s ease;
//         }

//         .get-directions-btn:hover {
//           background: linear-gradient(135deg, #d65a23, #ff8b5e);
//         }

//         .quick-contact {
//           background: white;
//           border-radius: 25px;
//           padding: 2.5rem;
//           box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
//         }

//         .quick-contact-title {
//           font-size: 1.5rem;
//           font-weight: 700;
//           color: #1B4965;
//           margin-bottom: 1.5rem;
//           font-family: 'Playfair Display', serif;
//         }

//         .social-links {
//           display: flex;
//           gap: 1rem;
//           flex-wrap: wrap;
//         }

//         .social-link {
//           width: 50px;
//           height: 50px;
//           border-radius: 12px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           color: white;
//           text-decoration: none;
//           transition: all 0.3s ease;
//         }

//         .social-link:hover {
//           transform: translateY(-5px);
//           box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
//         }

//         /* Form Section */
//         .form-section {
//           background: white;
//           border-radius: 25px;
//           padding: 3rem;
//           box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
//         }

//         .form-header {
//           margin-bottom: 2.5rem;
//         }

//         .form-title {
//           font-size: 2.5rem;
//           font-weight: 800;
//           color: #1B4965;
//           margin-bottom: 0.8rem;
//           font-family: 'Playfair Display', serif;
//         }

//         .form-subtitle {
//           font-size: 1.05rem;
//           color: #666;
//           line-height: 1.7;
//         }

//         .contact-form {
//           display: flex;
//           flex-direction: column;
//           gap: 1.5rem;
//         }

//         .form-row {
//           display: grid;
//           grid-template-columns: 1fr 1fr;
//           gap: 1.5rem;
//         }

//         .form-group {
//           display: flex;
//           flex-direction: column;
//           gap: 0.5rem;
//         }

//         .form-label {
//           font-weight: 600;
//           color: #1B4965;
//           font-size: 0.95rem;
//           display: flex;
//           align-items: center;
//           gap: 0.5rem;
//         }

//         .form-input,
//         .form-select,
//         .form-textarea {
//           padding: 1rem 1.2rem;
//           border: 2px solid #e0e0e0;
//           border-radius: 12px;
//           font-size: 1rem;
//           font-family: 'Inter', sans-serif;
//           transition: all 0.3s ease;
//           background: #F8FAFB;
//         }

//         .form-input:focus,
//         .form-select:focus,
//         .form-textarea:focus {
//           outline: none;
//           border-color: #E86A33;
//           background: white;
//           box-shadow: 0 0 0 4px rgba(232, 106, 51, 0.1);
//         }

//         .form-textarea {
//           min-height: 150px;
//           resize: vertical;
//         }

//         .form-submit-btn {
//           padding: 1.2rem 3rem;
//           background: linear-gradient(135deg, #E86A33, #FF9B6E);
//           color: white;
//           border: none;
//           border-radius: 50px;
//           font-weight: 700;
//           font-size: 1.05rem;
//           cursor: pointer;
//           display: inline-flex;
//           align-items: center;
//           justify-content: center;
//           gap: 0.7rem;
//           transition: all 0.3s ease;
//           box-shadow: 0 6px 20px rgba(232, 106, 51, 0.3);
//           align-self: flex-start;
//         }

//         .form-submit-btn:hover {
//           transform: translateY(-3px);
//           box-shadow: 0 10px 30px rgba(232, 106, 51, 0.4);
//         }

//         .form-submit-btn:disabled {
//           opacity: 0.6;
//           cursor: not-allowed;
//           transform: none;
//         }

//         /* Success Message */
//         .success-message {
//           background: linear-gradient(135deg, #10b981, #059669);
//           color: white;
//           padding: 1.5rem;
//           border-radius: 15px;
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//           animation: slideInRight 0.5s ease;
//         }

//         @keyframes slideInRight {
//           from {
//             opacity: 0;
//             transform: translateX(50px);
//           }
//           to {
//             opacity: 1;
//             transform: translateX(0);
//           }
//         }

//         /* Department Badges */
//         .department-section {
//           margin-top: 2rem;
//           padding-top: 2rem;
//           border-top: 2px solid #f0f0f0;
//         }

//         .department-title {
//           font-size: 1rem;
//           font-weight: 700;
//           color: #1B4965;
//           margin-bottom: 1rem;
//           text-transform: uppercase;
//           letter-spacing: 1px;
//         }

//         .department-badges {
//           display: flex;
//           flex-wrap: wrap;
//           gap: 0.8rem;
//         }

//         .department-badge {
//           padding: 0.6rem 1.2rem;
//           background: linear-gradient(135deg, #F8FAFB, #e0e0e0);
//           border: 2px solid #e0e0e0;
//           border-radius: 50px;
//           font-size: 0.9rem;
//           font-weight: 600;
//           color: #1B4965;
//           cursor: pointer;
//           transition: all 0.3s ease;
//         }

//         .department-badge:hover {
//           background: linear-gradient(135deg, #E86A33, #FF9B6E);
//           border-color: #E86A33;
//           color: white;
//           transform: translateY(-2px);
//         }

//         /* Responsive */
//         @media (max-width: 1024px) {
//           .contact-main {
//             grid-template-columns: 1fr;
//             gap: 3rem;
//           }

//           .map-section {
//             position: relative;
//             top: 0;
//           }
//         }

//         @media (max-width: 768px) {
//           .contact-hero-title {
//             font-size: 2.5rem;
//           }

//           .contact-hero-subtitle {
//             font-size: 1.1rem;
//           }

//           .contact-info-grid {
//             grid-template-columns: 1fr;
//           }

//           .form-row {
//             grid-template-columns: 1fr;
//           }

//           .form-section {
//             padding: 2rem;
//           }

//           .form-title {
//             font-size: 2rem;
//           }

//           .form-submit-btn {
//             width: 100%;
//           }
//         }
//       `}</style>

//       <div className="contact-page">
//         {/* Hero Section */}
//         <section className="contact-hero">
//           <div className="contact-hero-content">
//             <div className="contact-label">Get In Touch</div>
//             <h1 className="contact-hero-title">Contact Us</h1>
//             <p className="contact-hero-subtitle">
//               We're here to answer your questions and schedule your appointments
//             </p>
//           </div>
//         </section>

//         {/* Contact Info Cards */}
//         <section className="contact-info-section">
//           <div className="contact-info-grid">
//             {contactInfo.map((info, index) => (
//               <div 
//                 key={index} 
//                 className="contact-info-card"
//                 style={{
//                   animation: `fadeInUp 0.6s ease ${index * 0.1}s both`
//                 }}
//               >
//                 <div style={{['--card-color']: info.color}}>
//                   <style>{`
//                     .contact-info-card:nth-child(${index + 1})::before {
//                       background: ${info.color};
//                     }
//                   `}</style>
//                 </div>
//                 <div 
//                   className="contact-icon-wrapper"
//                   style={{background: `linear-gradient(135deg, ${info.color}, ${info.color}dd)`}}
//                 >
//                   {info.icon}
//                 </div>
//                 <h3 className="contact-info-title">{info.title}</h3>
//                 <div className="contact-info-details">
//                   {info.details.map((detail, idx) => (
//                     <div key={idx} className="contact-detail-item">
//                       {detail.includes('@') ? (
//                         <a href={`mailto:${detail}`}>{detail}</a>
//                       ) : detail.includes('+91') ? (
//                         <a href={`tel:${detail.replace(/\s/g, '')}`}>{detail}</a>
//                       ) : (
//                         detail
//                       )}
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* Main Content */}
//           <div className="contact-main">
//             {/* Map & Quick Contact */}
//             <div className="map-section">
//               <div className="map-container">
//                 <div className="map-placeholder">
//                   {/* Replace with actual Google Maps embed */}
//                   <iframe 
//                     className="map-iframe"
//                     src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d30501.234567890123!2d78.3273245!3d17.5235019!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb97e8c381ac23%3A0xfe9ce3ea62dd7f0a!2sGyani%20Arcade%2C%20Plot%20no%205%2C%20st%20no%2C%209-5%2F39%2C%20Rajendranagar%2C%20Hydershakote%2C%20Telangana%20500091!5e0!3m2!1sen!2sin!4v1735041234567!5m2!1sen!2sin"
//                     allowFullScreen=""
//                     loading="lazy"
//                     title="VAYU Lung Care Location"
//                   ></iframe>
//                 </div>
//                 <button className="get-directions-btn">
//                   <MapPin size={20} />
//                   Get Directions
//                 </button>
//               </div>

//               <div className="quick-contact">
//                 <h3 className="quick-contact-title">Connect With Us</h3>
//                 <div className="social-links">
//                   {socialLinks.map((social, index) => (
//                     <a 
//                       key={index}
//                       href={social.href}
//                       className="social-link"
//                       style={{background: social.color}}
//                       target="_blank"
//                       rel="noopener noreferrer"
//                     >
//                       {social.icon}
//                     </a>
//                   ))}
//                 </div>
//               </div>
//             </div>

//             {/* Contact Form */}
//             <div className="form-section">
//               <div className="form-header">
//                 <h2 className="form-title">Send Us a Message</h2>
//                 <p className="form-subtitle">
//                   Fill out the form below and our team will get back to you within 24 hours
//                 </p>
//               </div>

//               {formStatus === 'success' ? (
//                 <div className="success-message">
//                   <CheckCircle size={24} />
//                   <div>
//                     <strong>Message Sent Successfully!</strong>
//                     <p style={{marginTop: '0.3rem', fontSize: '0.9rem'}}>We'll get back to you soon.</p>
//                   </div>
//                 </div>
//               ) : (
//                 <form className="contact-form" onSubmit={handleSubmit}>
//                   <div className="form-row">
//                     <div className="form-group">
//                       <label className="form-label">
//                         <User size={16} />
//                         Full Name *
//                       </label>
//                       <input 
//                         type="text" 
//                         name="name"
//                         className="form-input"
//                         placeholder="Enter your full name"
//                         value={formData.name}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                     <div className="form-group">
//                       <label className="form-label">
//                         <Mail size={16} />
//                         Email Address *
//                       </label>
//                       <input 
//                         type="email" 
//                         name="email"
//                         className="form-input"
//                         placeholder="your.email@example.com"
//                         value={formData.email}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                   </div>

//                   <div className="form-row">
//                     <div className="form-group">
//                       <label className="form-label">
//                         <Phone size={16} />
//                         Phone Number *
//                       </label>
//                       <input 
//                         type="tel" 
//                         name="phone"
//                         className="form-input"
//                         placeholder="+91 123 456 7890"
//                         value={formData.phone}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                     <div className="form-group">
//                       <label className="form-label">
//                         <MessageSquare size={16} />
//                         Subject *
//                       </label>
//                       <select 
//                         name="subject"
//                         className="form-select"
//                         value={formData.subject}
//                         onChange={handleChange}
//                         required
//                       >
//                         <option value="">Select a subject</option>
//                         <option value="appointment">Book Appointment</option>
//                         <option value="inquiry">General Inquiry</option>
//                         <option value="emergency">Emergency</option>
//                         <option value="feedback">Feedback</option>
//                         <option value="other">Other</option>
//                       </select>
//                     </div>
//                   </div>

//                   <div className="form-row">
//                     <div className="form-group">
//                       <label className="form-label">
//                         <Calendar size={16} />
//                         Preferred Date
//                       </label>
//                       <input 
//                         type="date" 
//                         name="preferredDate"
//                         className="form-input"
//                         value={formData.preferredDate}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="form-group">
//                       <label className="form-label">
//                         <Clock size={16} />
//                         Preferred Time
//                       </label>
//                       <input 
//                         type="time" 
//                         name="preferredTime"
//                         className="form-input"
//                         value={formData.preferredTime}
//                         onChange={handleChange}
//                       />
//                     </div>
//                   </div>

//                   <div className="form-group">
//                     <label className="form-label">
//                       <MessageSquare size={16} />
//                       Your Message *
//                     </label>
//                     <textarea 
//                       name="message"
//                       className="form-textarea"
//                       placeholder="Tell us about your inquiry or health concern..."
//                       value={formData.message}
//                       onChange={handleChange}
//                       required
//                     ></textarea>
//                   </div>

//                   <div className="department-section">
//                     <div className="department-title">Select Department (Optional)</div>
//                     <div className="department-badges">
//                       {departments.map((dept, index) => (
//                         <div key={index} className="department-badge">
//                           {dept}
//                         </div>
//                       ))}
//                     </div>
//                   </div>

//                   <button type="submit" className="form-submit-btn">
//                     <Send size={20} />
//                     Send Message
//                   </button>
//                 </form>
//               )}
//             </div>
//           </div>
//         </section>
//       </div>
//     </>
//   );
// };

// export default ContactPage;



import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import { 
  Phone, 
  Mail, 
  MapPin, 
  Clock, 
  Send,
  CheckCircle,
  User,
  MessageSquare,
  Calendar,
  AlertCircle,
  Facebook,
  Instagram,
  Twitter,
  Linkedin,
  Youtube
} from 'lucide-react';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
    preferredDate: '',
    preferredTime: '',
    department: ''
  });

  const [formStatus, setFormStatus] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleDepartmentClick = (dept) => {
    setFormData({
      ...formData,
      department: dept
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // EmailJS configuration
    const serviceID = 'service_6om338p'; // Replace with your EmailJS service ID
    const templateID = 'template_nm2jvln'; // Replace with your EmailJS template ID
    const publicKey = 'BzfDxZQayXA87zGbE'; // Replace with your EmailJS public key

    // Prepare template parameters
    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      phone: formData.phone,
      subject: formData.subject,
      message: formData.message,
      preferred_date: formData.preferredDate || 'Not specified',
      preferred_time: formData.preferredTime || 'Not specified',
      department: formData.department || 'Not specified',
      to_email: 'vayulungcare@gmail.com'
    };

    // Send email using EmailJS
    emailjs.send(serviceID, templateID, templateParams, publicKey)
      .then((response) => {
        console.log('SUCCESS!', response.status, response.text);
        setFormStatus('success');
        setIsSubmitting(false);
        
        // Reset form after 3 seconds
        setTimeout(() => {
          setFormStatus(null);
          setFormData({
            name: '',
            email: '',
            phone: '',
            subject: '',
            message: '',
            preferredDate: '',
            preferredTime: '',
            department: ''
          });
        }, 3000);
      })
      .catch((error) => {
        console.error('FAILED...', error);
        setFormStatus('error');
        setIsSubmitting(false);
        
        // Clear error message after 5 seconds
        setTimeout(() => {
          setFormStatus(null);
        }, 5000);
      });
  };

  const contactInfo = [
    {
      icon: <MapPin className="w-6 h-6" />,
      title: "Visit Our Clinic",
      details: ["4th Floor, Gyani Arcade", "Suncity Main Road, Hydershakote,", "Rajendranagar, Ranga Reddy District – 500091"],
      color: "#E86A33"
    },
    {
      icon: <Phone className="w-6 h-6" />,
      title: "Call Us",
      details: ["+91 9989162222"],
      color: "#2C85B8"
    },
    {
      icon: <Mail className="w-6 h-6" />,
      title: "Email Us",
      details: ["vayulungcare@gmail.com"],
      color: "#1B4965"
    },
    {
      icon: <Clock className="w-6 h-6" />,
      title: "Working Hours",
      details: ["Mon - Sat: 9:00 AM - 9:00 PM", "Sunday: 9:00 AM - 1:00 PM"],
      color: "#62B6CB"
    }
  ];

  const departments = [
    "Pulmonology",
    "Cardiology",
    "Critical Care",
    "General Medicine",
    "Allergy Testing",
    "Diagnostics"
  ];

  const socialLinks = [
    // { icon: <Facebook size={20} />, href: "#", color: "#1877F2" },
    { icon: <Instagram size={20} />, href: "https://www.instagram.com/vayulungcare?igsh=cnFpZDZtNzEwMHVv", color: "#E4405F" },
    // { icon: <Twitter size={20} />, href: "#", color: "#1DA1F2" },
    // { icon: <Linkedin size={20} />, href: "#", color: "#0A66C2" },
    { icon: <Youtube size={20} />, href: "https://youtube.com/@vayulungcare?si=Qm7gizDqR5zF9M4y", color: "#FF0000" }
  ];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;800&family=Inter:wght@300;400;500;600;700;800&display=swap');
        
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          font-family: 'Inter', sans-serif;
          color: #1a1a1a;
        }

        .contact-page {
          width: 100%;
          min-height: 100vh;
          background: linear-gradient(135deg, #F8FAFB 0%, white 100%);
        }

        /* Hero Section */
        .contact-hero {
          position: relative;
          height: 50vh;
          min-height: 400px;
          background: linear-gradient(135deg, #1B4965 0%, #2C5F7C 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }

        .contact-hero::before {
          content: '';
          position: absolute;
          top: -50%;
          right: -20%;
          width: 70%;
          height: 200%;
          background: radial-gradient(circle, rgba(232, 106, 51, 0.15) 0%, transparent 70%);
          animation: rotate 30s linear infinite;
        }

        @keyframes rotate {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        .contact-hero-content {
          text-align: center;
          color: white;
          z-index: 2;
          max-width: 800px;
          padding: 2rem;
        }

        .contact-label {
          font-size: 0.95rem;
          font-weight: 700;
          color: #FFD700;
          letter-spacing: 4px;
          text-transform: uppercase;
          margin-bottom: 1.5rem;
          animation: fadeInDown 0.8s ease;
        }

        .contact-hero-title {
          font-family: 'Playfair Display', serif;
          font-size: 4rem;
          font-weight: 800;
          margin-bottom: 1rem;
          line-height: 1.1;
          animation: fadeInUp 0.8s ease 0.2s both;
        }

        .contact-hero-subtitle {
          font-size: 1.3rem;
          opacity: 0.95;
          font-weight: 300;
          animation: fadeInUp 0.8s ease 0.4s both;
        }

        @keyframes fadeInDown {
          from { opacity: 0; transform: translateY(-30px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }

        /* Contact Info Cards */
        .contact-info-section {
          max-width: 1400px;
          margin: -80px auto 0;
          padding: 0 2rem 4rem;
          position: relative;
          z-index: 10;
        }

        .contact-info-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 2rem;
          margin-bottom: 4rem;
        }

        .contact-info-card {
          background: white;
          border-radius: 25px;
          padding: 2.5rem;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
          transition: all 0.4s ease;
          position: relative;
          overflow: hidden;
        }

        .contact-info-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 5px;
          transform: scaleX(0);
          transform-origin: left;
          transition: transform 0.4s ease;
        }

        .contact-info-card:hover::before {
          transform: scaleX(1);
        }

        .contact-info-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 60px rgba(27, 73, 101, 0.15);
        }

        .contact-icon-wrapper {
          width: 70px;
          height: 70px;
          border-radius: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          margin-bottom: 1.5rem;
          transition: all 0.4s ease;
        }

        .contact-info-card:hover .contact-icon-wrapper {
          transform: rotate(-5deg) scale(1.1);
        }

        .contact-info-title {
          font-size: 1.3rem;
          font-weight: 700;
          color: #1B4965;
          margin-bottom: 1rem;
          font-family: 'Playfair Display', serif;
        }

        .contact-info-details {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }

        .contact-detail-item {
          font-size: 0.95rem;
          color: #666;
          line-height: 1.6;
        }

        .contact-detail-item a {
          color: #666;
          text-decoration: none;
          transition: color 0.3s ease;
        }

        .contact-detail-item a:hover {
          color: #E86A33;
        }

        /* Main Content */
        .contact-main {
          max-width: 1400px;
          margin: 0 auto;
          padding: 0 2rem 6rem;
          display: grid;
          grid-template-columns: 1fr 1.2fr;
          gap: 4rem;
          align-items: start;
        }

        /* Map Section */
        .map-section {
          position: sticky;
          top: 120px;
        }

        .map-container {
          background: white;
          border-radius: 25px;
          overflow: hidden;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
          margin-bottom: 2rem;
        }

        .map-iframe {
          width: 100%;
          height: 400px;
          border: none;
        }

        .get-directions-btn {
          width: 100%;
          padding: 1.2rem;
          background: linear-gradient(135deg, #E86A33, #FF9B6E);
          color: white;
          border: none;
          font-weight: 700;
          font-size: 1rem;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.7rem;
          transition: all 0.3s ease;
          text-decoration: none;
        }

        .get-directions-btn:hover {
          background: linear-gradient(135deg, #d65a23, #ff8b5e);
        }

        .quick-contact {
          background: white;
          border-radius: 25px;
          padding: 2.5rem;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
        }

        .quick-contact-title {
          font-size: 1.5rem;
          font-weight: 700;
          color: #1B4965;
          margin-bottom: 1.5rem;
          font-family: 'Playfair Display', serif;
        }

        .social-links {
          display: flex;
          gap: 1rem;
          flex-wrap: wrap;
        }

        .social-link {
          width: 50px;
          height: 50px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .social-link:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
        }

        /* Form Section */
        .form-section {
          background: white;
          border-radius: 25px;
          padding: 3rem;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
        }

        .form-header {
          margin-bottom: 2.5rem;
        }

        .form-title {
          font-size: 2.5rem;
          font-weight: 800;
          color: #1B4965;
          margin-bottom: 0.8rem;
          font-family: 'Playfair Display', serif;
        }

        .form-subtitle {
          font-size: 1.05rem;
          color: #666;
          line-height: 1.7;
        }

        .contact-form {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1.5rem;
        }

        .form-group {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }

        .form-label {
          font-weight: 600;
          color: #1B4965;
          font-size: 0.95rem;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .form-input,
        .form-select,
        .form-textarea {
          padding: 1rem 1.2rem;
          border: 2px solid #e0e0e0;
          border-radius: 12px;
          font-size: 1rem;
          font-family: 'Inter', sans-serif;
          transition: all 0.3s ease;
          background: #F8FAFB;
        }

        .form-input:focus,
        .form-select:focus,
        .form-textarea:focus {
          outline: none;
          border-color: #E86A33;
          background: white;
          box-shadow: 0 0 0 4px rgba(232, 106, 51, 0.1);
        }

        .form-textarea {
          min-height: 150px;
          resize: vertical;
        }

        .form-submit-btn {
          padding: 1.2rem 3rem;
          background: linear-gradient(135deg, #E86A33, #FF9B6E);
          color: white;
          border: none;
          border-radius: 50px;
          font-weight: 700;
          font-size: 1.05rem;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 0.7rem;
          transition: all 0.3s ease;
          box-shadow: 0 6px 20px rgba(232, 106, 51, 0.3);
          align-self: flex-start;
        }

        .form-submit-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 30px rgba(232, 106, 51, 0.4);
        }

        .form-submit-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        /* Success/Error Messages */
        .success-message {
          background: linear-gradient(135deg, #10b981, #059669);
          color: white;
          padding: 1.5rem;
          border-radius: 15px;
          display: flex;
          align-items: center;
          gap: 1rem;
          animation: slideInRight 0.5s ease;
        }

        .error-message {
          background: linear-gradient(135deg, #ef4444, #dc2626);
          color: white;
          padding: 1.5rem;
          border-radius: 15px;
          display: flex;
          align-items: center;
          gap: 1rem;
          animation: slideInRight 0.5s ease;
        }

        @keyframes slideInRight {
          from {
            opacity: 0;
            transform: translateX(50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        /* Department Badges */
        .department-section {
          margin-top: 2rem;
          padding-top: 2rem;
          border-top: 2px solid #f0f0f0;
        }

        .department-title {
          font-size: 1rem;
          font-weight: 700;
          color: #1B4965;
          margin-bottom: 1rem;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .department-badges {
          display: flex;
          flex-wrap: wrap;
          gap: 0.8rem;
        }

        .department-badge {
          padding: 0.6rem 1.2rem;
          background: linear-gradient(135deg, #F8FAFB, #e0e0e0);
          border: 2px solid #e0e0e0;
          border-radius: 50px;
          font-size: 0.9rem;
          font-weight: 600;
          color: #1B4965;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .department-badge:hover,
        .department-badge.active {
          background: linear-gradient(135deg, #E86A33, #FF9B6E);
          border-color: #E86A33;
          color: white;
          transform: translateY(-2px);
        }

        /* Responsive Design */
        @media (max-width: 1400px) {
          .contact-info-section {
            padding: 0 1.5rem 3rem;
          }

          .contact-main {
            padding: 0 1.5rem 5rem;
          }
        }

        @media (max-width: 1200px) {
          .contact-info-grid {
            gap: 1.5rem;
          }

          .contact-main {
            gap: 3rem;
          }
        }

        @media (max-width: 1024px) {
          .contact-main {
            grid-template-columns: 1fr;
            gap: 3rem;
          }

          .map-section {
            position: relative;
            top: 0;
          }

          .contact-hero {
            height: 45vh;
            min-height: 350px;
          }

          .contact-hero-title {
            font-size: 3.5rem;
          }
        }

        @media (max-width: 768px) {
          .contact-hero {
            height: 40vh;
            min-height: 300px;
          }

          .contact-hero-content {
            padding: 1.5rem;
          }

          .contact-label {
            font-size: 0.85rem;
            letter-spacing: 3px;
            margin-bottom: 1rem;
          }

          .contact-hero-title {
            font-size: 2.5rem;
            margin-bottom: 0.8rem;
          }

          .contact-hero-subtitle {
            font-size: 1.1rem;
          }

          .contact-info-section {
            margin-top: -60px;
            padding: 0 1rem 2rem;
          }

          .contact-info-grid {
            grid-template-columns: 1fr;
            gap: 1.5rem;
            margin-bottom: 3rem;
          }

          .contact-info-card {
            padding: 2rem;
            border-radius: 20px;
          }

          .contact-icon-wrapper {
            width: 60px;
            height: 60px;
          }

          .contact-info-title {
            font-size: 1.2rem;
          }

          .contact-detail-item {
            font-size: 0.9rem;
          }

          .contact-main {
            padding: 0 1rem 4rem;
            gap: 2rem;
          }

          .map-iframe {
            height: 300px;
          }

          .quick-contact {
            padding: 2rem;
            border-radius: 20px;
          }

          .quick-contact-title {
            font-size: 1.3rem;
          }

          .social-link {
            width: 45px;
            height: 45px;
          }

          .form-section {
            padding: 2rem;
            border-radius: 20px;
          }

          .form-title {
            font-size: 2rem;
          }

          .form-subtitle {
            font-size: 1rem;
          }

          .form-row {
            grid-template-columns: 1fr;
            gap: 1.2rem;
          }

          .contact-form {
            gap: 1.2rem;
          }

          .form-input,
          .form-select,
          .form-textarea {
            padding: 0.9rem 1rem;
            font-size: 0.95rem;
          }

          .form-submit-btn {
            width: 100%;
            padding: 1rem 2rem;
          }

          .department-badges {
            gap: 0.6rem;
          }

          .department-badge {
            padding: 0.5rem 1rem;
            font-size: 0.85rem;
          }
        }

        @media (max-width: 480px) {
          .contact-hero {
            min-height: 250px;
          }

          .contact-hero-content {
            padding: 1rem;
          }

          .contact-label {
            font-size: 0.75rem;
            letter-spacing: 2px;
          }

          .contact-hero-title {
            font-size: 2rem;
          }

          .contact-hero-subtitle {
            font-size: 1rem;
          }

          .contact-info-section {
            margin-top: -50px;
            padding: 0 0.8rem 1.5rem;
          }

          .contact-info-grid {
            gap: 1.2rem;
            margin-bottom: 2rem;
          }

          .contact-info-card {
            padding: 1.5rem;
            border-radius: 15px;
          }

          .contact-icon-wrapper {
            width: 55px;
            height: 55px;
          }

          .contact-info-title {
            font-size: 1.1rem;
            margin-bottom: 0.8rem;
          }

          .contact-detail-item {
            font-size: 0.85rem;
          }

          .contact-main {
            padding: 0 0.8rem 3rem;
            gap: 1.5rem;
          }

          .map-iframe {
            height: 250px;
          }

          .get-directions-btn {
            padding: 1rem;
            font-size: 0.95rem;
          }

          .quick-contact {
            padding: 1.5rem;
            border-radius: 15px;
          }

          .quick-contact-title {
            font-size: 1.2rem;
            margin-bottom: 1.2rem;
          }

          .social-links {
            gap: 0.8rem;
          }

          .social-link {
            width: 42px;
            height: 42px;
          }

          .form-section {
            padding: 1.5rem;
            border-radius: 15px;
          }

          .form-header {
            margin-bottom: 2rem;
          }

          .form-title {
            font-size: 1.8rem;
            margin-bottom: 0.6rem;
          }

          .form-subtitle {
            font-size: 0.95rem;
            line-height: 1.6;
          }

          .form-label {
            font-size: 0.9rem;
          }

          .form-input,
          .form-select,
          .form-textarea {
            padding: 0.8rem 0.9rem;
            font-size: 0.9rem;
            border-radius: 10px;
          }

          .form-textarea {
            min-height: 120px;
          }

          .form-submit-btn {
            padding: 0.9rem 1.5rem;
            font-size: 1rem;
          }

          .department-section {
            margin-top: 1.5rem;
            padding-top: 1.5rem;
          }

          .department-title {
            font-size: 0.9rem;
            margin-bottom: 0.8rem;
          }

          .department-badges {
            gap: 0.5rem;
          }

          .department-badge {
            padding: 0.4rem 0.9rem;
            font-size: 0.8rem;
          }

          .success-message,
          .error-message {
            padding: 1.2rem;
            font-size: 0.9rem;
          }
        }

        @media (max-width: 360px) {
          .contact-hero-title {
            font-size: 1.8rem;
          }

          .contact-info-card {
            padding: 1.2rem;
          }

          .form-section {
            padding: 1.2rem;
          }

          .form-title {
            font-size: 1.6rem;
          }
        }
      `}</style>

      <div className="contact-page">
        {/* Hero Section */}
        <section className="contact-hero">
          <div className="contact-hero-content">
            <div className="contact-label">Get In Touch</div>
            <h1 className="contact-hero-title">Contact Us</h1>
            <p className="contact-hero-subtitle">
              We're here to answer your questions and schedule your appointments
            </p>
          </div>
        </section>

        {/* Contact Info Cards */}
        <section className="contact-info-section">
          <div className="contact-info-grid">
            {contactInfo.map((info, index) => (
              <div 
                key={index} 
                className="contact-info-card"
                style={{
                  animation: `fadeInUp 0.6s ease ${index * 0.1}s both`
                }}
              >
                <div style={{['--card-color']: info.color}}>
                  <style>{`
                    .contact-info-card:nth-child(${index + 1})::before {
                      background: ${info.color};
                    }
                  `}</style>
                </div>
                <div 
                  className="contact-icon-wrapper"
                  style={{background: `linear-gradient(135deg, ${info.color}, ${info.color}dd)`}}
                >
                  {info.icon}
                </div>
                <h3 className="contact-info-title">{info.title}</h3>
                <div className="contact-info-details">
                  {info.details.map((detail, idx) => (
                    <div key={idx} className="contact-detail-item">
                      {detail.includes('@') ? (
                        <a href={`mailto:${detail}`}>{detail}</a>
                      ) : detail.includes('+91') ? (
                        <a href={`tel:${detail.replace(/\s/g, '')}`}>{detail}</a>
                      ) : (
                        detail
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Main Content */}
          <div className="contact-main">
            {/* Map & Quick Contact */}
            <div className="map-section">
              <div className="map-container">
                <iframe 
                  className="map-iframe"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d30501.234567890123!2d78.3273245!3d17.5235019!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb97e8c381ac23%3A0xfe9ce3ea62dd7f0a!2sGyani%20Arcade%2C%20Plot%20no%205%2C%20st%20no%2C%209-5%2F39%2C%20Rajendranagar%2C%20Hydershakote%2C%20Telangana%20500091!5e0!3m2!1sen!2sin!4v1735041234567!5m2!1sen!2sin"
                  allowFullScreen=""
                  loading="lazy"
                  title="VAYU Lung Care Location"
                ></iframe>
                <a 
                  href="https://www.google.com/maps/dir//Gyani+Arcade,+Plot+no+5,+st+no,+9-5/39,+Rajendranagar,+Hydershakote,+Telangana+500091"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="get-directions-btn"
                >
                  <MapPin size={20} />
                  Get Directions
                </a>
              </div>

              <div className="quick-contact">
                <h3 className="quick-contact-title">Connect With Us</h3>
                <div className="social-links">
                  {socialLinks.map((social, index) => (
                    <a 
                      key={index}
                      href={social.href}
                      className="social-link"
                      style={{background: social.color}}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {social.icon}
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="form-section">
              <div className="form-header">
                <h2 className="form-title">Send Us a Message</h2>
                <p className="form-subtitle">
                  Fill out the form below and our team will get back to you within 24 hours
                </p>
              </div>

              {formStatus === 'success' ? (
                <div className="success-message">
                  <CheckCircle size={24} />
                  <div>
                    <strong>Message Sent Successfully!</strong>
                    <p style={{marginTop: '0.3rem', fontSize: '0.9rem'}}>We'll get back to you soon.</p>
                  </div>
                </div>
              ) : formStatus === 'error' ? (
                <div className="error-message">
                  <AlertCircle size={24} />
                  <div>
                    <strong>Oops! Something went wrong.</strong>
                    <p style={{marginTop: '0.3rem', fontSize: '0.9rem'}}>Please try again or call us directly.</p>
                  </div>
                </div>
              ) : (
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label">
                        <User size={16} />
                        Full Name *
                      </label>
                      <input 
                        type="text" 
                        name="name"
                        className="form-input"
                        placeholder="Enter your full name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        <Mail size={16} />
                        Email Address *
                      </label>
                      <input 
                        type="email" 
                        name="email"
                        className="form-input"
                        placeholder="your.email@example.com"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label">
                        <Phone size={16} />
                        Phone Number *
                      </label>
                      <input 
                        type="tel" 
                        name="phone"
                        className="form-input"
                        placeholder="+91 123 456 7890"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        <MessageSquare size={16} />
                        Subject *
                      </label>
                      <select 
                        name="subject"
                        className="form-select"
                        value={formData.subject}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select a subject</option>
                        <option value="appointment">Book Appointment</option>
                        <option value="inquiry">General Inquiry</option>
                        <option value="emergency">Emergency</option>
                        <option value="feedback">Feedback</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label">
                        <Calendar size={16} />
                        Preferred Date
                      </label>
                      <input 
                        type="date" 
                        name="preferredDate"
                        className="form-input"
                        value={formData.preferredDate}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        <Clock size={16} />
                        Preferred Time
                      </label>
                      <input 
                        type="time" 
                        name="preferredTime"
                        className="form-input"
                        value={formData.preferredTime}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      <MessageSquare size={16} />
                      Your Message *
                    </label>
                    <textarea 
                      name="message"
                      className="form-textarea"
                      placeholder="Tell us about your inquiry or health concern..."
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>

                  <div className="department-section">
                    <div className="department-title">Select Department (Optional)</div>
                    <div className="department-badges">
                      {departments.map((dept, index) => (
                        <div 
                          key={index} 
                          className={`department-badge ${formData.department === dept ? 'active' : ''}`}
                          onClick={() => handleDepartmentClick(dept)}
                        >
                          {dept}
                        </div>
                      ))}
                    </div>
                  </div>

                  <button 
                    type="submit" 
                    className="form-submit-btn"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <div style={{
                          width: '20px',
                          height: '20px',
                          border: '3px solid rgba(255,255,255,0.3)',
                          borderTop: '3px solid white',
                          borderRadius: '50%',
                          animation: 'spin 0.8s linear infinite'
                        }}></div>
                        Sending...
                      </>
                    ) : (
                      <>
                        <Send size={20} />
                        Send Message
                      </>
                    )}
                  </button>
                </form>
              )}
            </div>
          </div>
        </section>
      </div>

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
};

export default ContactPage;